import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FirebaseService } from '../service/firebase.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserCreationModalComponent } from '../user-creation-modal/user-creation-modal.component';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';
import { GroupCreationModalComponent } from '../group-creation-modal/group-creation-modal.component';
import { AngularFireStorage } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';
import { UpdateUserEmailComponent } from '../modals/user-modal/update-user-email.component';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  users: any;
  groups: any;
  devices: any;
  filterValue: any;
  filteredUser: any;

  userNameControl = new UntypedFormControl(null);
  constructor(public firebaseService: FirebaseService, public dialog: MatDialog, private _ref: ChangeDetectorRef, private _http: HttpClient, private storage: AngularFireStorage) { }

  ngOnInit() {
    this.firebaseService.getUsersCollection().subscribe((data) => {
      this.users = data;
      this.filteredUser = this.users
      this.users.sort(function (a, b) {
        if (a.displayName < b.displayName) { return -1; }
        if (a.displayName > b.displayName) { return 1; }
        return 0
      });




    })

    this.firebaseService.getAllGroups().then(data => {
      this.groups = data;
    })

    this.firebaseService.getAllDevices().then(data => {
      this.devices = data;
    })


  }

  /**
   * Filter the displayed user
   * @param val The filter input value
   */

  filterUsers(val) {
    this.filteredUser = this.users.filter(elem => {
      if (elem.displayName)
      return elem.displayName.toLowerCase().includes(val.toLowerCase())
    })
  }

  /**
   * Open dialog
   * @param type The modal's dialog
   * @param callback
   */
  openDialog(type, callback = (res) => { }): void {
    let dialogRef: any;

    switch (type) {
      case 'userCreation':
        dialogRef = this.dialog.open(UserCreationModalComponent, {
          width: '30vw',
          height: '40vh',
          data: {}
        });
        break;
      case 'deviceCreation':
        dialogRef = this.dialog.open(PromptModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Veuillez entrer un nom de borne' }
        });
        break;
      case 'deviceSuppression':
        dialogRef = this.dialog.open(ConfirmModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Êtes-vous sûr de vouloir supprimer cette borne ?' }
        });
        break;
      case 'groupCreation':
        dialogRef = this.dialog.open(PromptModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Veuillez entrer un nom de groupe' }
        })
        break;
      /* case 'groupSuppression':
         dialogRef = this.dialog.open()
         break;*/

    }
    dialogRef.afterClosed().subscribe(result => {
      callback(result)
    });
  }





  /**
   * Updateactive module in device
   * @param moduleName Module'sname
   * @param user selected user
   * @param device selected device
   * @param value new data
   */
  onModuleChange(moduleName, user, device, value) {


    user.groupsArray.forEach((group) => {

      group.devices.forEach((borne) => {
        if (borne.name == device.name)
          borne.modules[moduleName] = value.target.checked

      })

    })

    this.firebaseService.setUserDataElement(user.id, user)

  }







  /**
   * Open user creation dialog
   * */
  createNewUser(/*email, role, displayName,password*/) {

    this.openDialog('userCreation');
  }


}
